<template>
  <vector-tile-source :url="url" :source-id="sourceId">
    <layer-group
      :hide-layer="hideLayer"
      :layers="layers"
      :filter="filters"
      :before="props.before"
      @click="handleClick"
    >
      <template #hover="{ feature }">
        <LocationHover :hovered-feature="feature" />
      </template>
    </layer-group>
  </vector-tile-source>
</template>

<script setup lang="ts">
import { LayerSpecification, GeoJSONFeature, MapMouseEvent } from 'mapbox-gl'
import { computed } from 'vue'
import VectorTileSource from '../mapbox/VectorTileSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import LocationHover from '../hovers/LocationHover.vue'
import { useGetMapLayersQuery } from '@/api/mapping'
import { locationPinStyle } from './styles/location-pin'

const { data } = useGetMapLayersQuery()

const props = defineProps<{
  layerId: string
  sourceId: string
  hiddenFeatureIds?: (string | number)[]
  before?: string
  hideLayer?: boolean
}>()

const emits = defineEmits<{
  (event: 'click', data: GeoJSONFeature[], eventData: MapMouseEvent)
}>()

const handleClick = (data: GeoJSONFeature[], eventData: MapMouseEvent) => {
  emits('click', data, eventData)
}

const url = computed(() => {
  return data.value?.locations.url
})

const filters = computed(() => {
  const filter: any[] = ['all']

  const ids = props.hiddenFeatureIds || []
  if (ids.length > 0) {
    filter.push(['!', ['in', ['id'], ['literal', ids]]])
  }

  return filter
})

const layers: LayerSpecification[] = [
  {
    id: props.layerId,
    type: 'symbol',
    source: props.sourceId,
    'source-layer': 'get_locations_by_org_and_tenant',
    layout: {
      ...locationPinStyle.layout,
    },
    paint: {
      ...locationPinStyle.paint,
    },
  },
]
</script>
